import { useMemo } from 'react'

import { useGetAllDesktopSettingsQuery } from 'shared/api/containerApi'

import { selectDesktopWidgets } from '../utils/desktopWidgetAdapter'

/** Reads persisted widgets directly from the canonical /desktop/all cache. */
export const useDesktopWidgets = () => {
  const query = useGetAllDesktopSettingsQuery()
  const items = useMemo(() => selectDesktopWidgets(query.data), [query.data])

  return { ...query, items }
}
